import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.scss'],
})
export class PreloaderComponent implements OnInit {
  isHidden = false;
  logoUrl: string | null = null;

  ngOnInit() {
    const cached = localStorage.getItem('mainData');
    if (cached) {
      try {
        this.logoUrl = JSON.parse(cached)?.LogoUrl || null;
      } catch {
        this.logoUrl = null;
      }
    }

    const hide = () => setTimeout(() => { this.isHidden = true; }, 350);

    if (document.readyState === 'complete') {
      hide();
    } else {
      window.addEventListener('load', hide, { once: true });
      // Hard fallback: never show longer than 4 s
      setTimeout(() => { this.isHidden = true; }, 4000);
    }
  }
}
